import React from 'react';
import { TDR } from 'tdr-common';
import ArrowRight from '../../icons/right-icon.svg';
import { ProximityInfoContainer } from './ProximityInfoContainer';
import useNavigateWithQuery from '../../hooks/useNavigateWIthQuery';
import { analytics } from '../../helpers/analytics/analytics';
import { useTranslation } from 'react-i18next';

type LostYourWayProps = {
	table: Pick<TDR.Table, 'slug'>,
	navigateToPin: (table) => void
}
export const LostYourWay: React.FC<LostYourWayProps> = ({ table, navigateToPin }) => {
	const { t } = useTranslation();
	const navigateWithQuery = useNavigateWithQuery();

	const tableLink = `explore/${table.slug}`;

	let onClick = () => {
		navigateWithQuery(tableLink);
		analytics.track('Matterport Link Clicked', {
			link: tableLink,
			title: t('titles.lost_your_way')
		});
	};

	if (location.pathname.endsWith(tableLink)) {
		onClick = () => navigateToPin(table);
	}

	return (
		<ProximityInfoContainer
			title={t('titles.lost_your_way')}
			body={<>{t('messages.find_closest_table', { defaultValue: 'Let\'s find the closest table' })}</>}
			icon={ArrowRight}
			onClick={onClick}
			availableTable={true}
		/>
	);
};
